import {Locale} from '@hebcal/hdate';
import poData from './uk.po.js';
Locale.addLocale('uk', poData);
